/** Replace any character with codepoint > U+5FFF with a space. */
export function filterOutOfRangeChars(text: string): string {
  return text.replace(/./gsu, (char) => {
    const cp = char.codePointAt(0) ?? 0

    return cp > 0x5fff ? ' ' : char
  })
}

/** Number of spaces a pasted tab expands to — see `expandTabsToSpaces`. */
export const PASTED_TAB_WIDTH_SPACES = 4

/**
 * Expand tab characters to a fixed number of spaces (WMPCM-10141). Canvas 2D `measureText`
 * (this codebase's text measurement/rendering primitive — `shape-text-measure.ts`) has no
 * tab-stop concept: `measureText('\t')` returns the same width as a single space, so a pasted
 * tab silently collapses to one character's width instead of advancing to a column boundary
 * like the source app rendered it. There is no column-position context available at this
 * character-level sanitization layer to compute a true tab stop, so a fixed-width substitution
 * is used instead — the same approach many web text tools without native tab-stop rendering
 * already take for a pasted tab.
 */
export function expandTabsToSpaces(text: string): string {
  return text.replace(/\t/g, ' '.repeat(PASTED_TAB_WIDTH_SPACES))
}
